module.exports = __webpack_public_path__ + "img/07.e4cf4bf4.jpg";